module.exports = __webpack_public_path__ + "img/IMG_7490.12761afc.webp";